// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"components-Text-styles__root"};